import React, { useMemo, useContext } from 'react';
import { FormViewContent } from 'components/FormViewContent';
import { useDispatch, useSelector } from 'react-redux';
import { bindLogger } from 'helpers/BindLogger';
import { bindActionCreators } from 'redux';
import atoms from 'ctsutheme/components/atoms';
import { ProtocolIdSelector, ProtocolNumSelector } from 'selectors';
import { ValidatorForm } from 'components/FormHelpers/FormInputs';
import { CTSUCardActions } from 'components';
import { saveEmbeddedNP } from 'actions/protocols/opensetup';
import {
    Step, Required, Days, Start, End, Comments
} from 'containers/protocol/opensetup/components';
import { AppContext } from '@ctsu/loader';
import { useFormik } from 'formik';
import { compose } from 'recompose';
import { withChangeHandlers } from 'helpers/Change';
import moment from 'moment';
import { openSnackbar } from 'helpers/Notifier';
import { getApiDateFormat } from 'helpers';


const { Divider } = atoms;

export const handleDateChange = (state, setState, value, name) => {
    if (value != null) {
        setState({ ...state, [name]: getApiDateFormat(value) });
    }
}



const AddEmbeddedNpStudyFormCmp = ({ steps, onClose, formik }) => {

    const { handleSubmit, values, handleChange, setValues, handleReset } = formik;

    return (
        <ValidatorForm onSubmit={handleSubmit} className="key-value-pair-wrapper">
            <FormViewContent
                primaryText="Study Number"
                secondaryText={values.relatedProtocolNumber}
                name="relatedProtocolNumber"
            />
            <Divider />
            <FormViewContent
                primaryText="Step"
                secondaryText={
                    (<Step state={values} setState={setValues} steps={steps} />)
                }
                name="step"
            />
            <Divider />
            <FormViewContent
                primaryText="Study Type"
                secondaryText="EMBEDDED"
                name="embedded"
            />
            <Divider />
            <FormViewContent
                primaryText="Required?"
                secondaryText={
                    (<Required state={values} setState={setValues} />)
                }
                name="required"
            />
            <Divider />
            <FormViewContent
                primaryText="# Days"
                secondaryText={
                    (<Days state={values} handleChange={handleChange} />)
                }
                name="days"
            />
            <Divider />
            <FormViewContent
                primaryText="Start Date"
                secondaryText={
                    (<Start state={values} handleDateChange={(name) => eve => handleDateChange(values, setValues, eve, name)} setState={setValues} />)
                }
                name="startDate"
            />
            <Divider />
            <FormViewContent
                primaryText="End Date"
                secondaryText={
                    (<End state={values} handleDateChange={(name) => eve => handleDateChange(values, setValues, eve, name)} setState={setValues} />)
                }
                name="endDate"
            />
            <Divider />
            <FormViewContent
                primaryText="Comments"
                secondaryText={
                    (<Comments state={values} handleChange={handleChange} />)
                }
                name="comments"
            />
            <Divider />
            <CTSUCardActions
                clearClick={() => handleReset({})}
                cancelClick={onClose}
                hideCancel='show'
            />
        </ValidatorForm>
    );
};
export const  AddEmbeddedNpStudyForm = compose(withChangeHandlers)(AddEmbeddedNpStudyFormCmp);

export const AddEmbeddedNpStudy = (props) => {
    const {
        onClose,
        reloadPage
    } = props;
    
    const dispatch = useDispatch();
    const actions = useMemo(() => bindActionCreators({ saveEmbeddedNP }, dispatch), [dispatch]);
    
    const openSetupInfo = useSelector(state => state.openData.openData);

    const { protocolLogistics } = openSetupInfo;

    const context = useContext(AppContext);
    const protocolId = useSelector(ProtocolIdSelector);
    const protocolNumber = useSelector(ProtocolNumSelector);
    const steps = useMemo(() => protocolLogistics?.map(({ step, prlId, description }) => ({
        label: `Step : ${step} (${description})`,
        value: step,
        prlId
    }) || []), [protocolLogistics]);

    const formik = useFormik({
        initialValues: {
            "relatedProtocolNumber": `${protocolNumber}-NP`,
            "title": '',
            "alias":'',
            "step": steps?.[0]?.value || '',
            "prlId": steps?.[0]?.prlId || '',
            "isMandatory": false,
            "delayedEnrollDays": '0',
            "startDate": moment().format('DD-MMM-YYYY'),
            "endDate":  moment().format('DD-MMM-YYYY'),
            "comments": '',
            "relationType": "EMBEDDED",
            "prtId": protocolId
        },
        onSubmit: (values) => {
            bindLogger(actions.saveEmbeddedNP, context)(values, values.prtId).subscribe(() => {
                openSnackbar({
                    message: `Embedded study ${values.relatedProtocolNumber} created.`,
                    variant: 'success',
                    name: 'open'
                });
                onClose();
                reloadPage();
            })
        }
    });

    return (
        <AddEmbeddedNpStudyForm 
            onClose={onClose}
            reloadPage={reloadPage}
            steps={steps}
            formik={formik}
            />
    );
};


